import { useRouter } from "next/router";
import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";

const withAuth = (WrappedComponent: React.ComponentType) => {
  const Wrapper = (props: any) => {
    const router = useRouter();
    const { isAuthenticated, loading } = useAuth();

    useEffect(() => {
      if (!loading && !isAuthenticated) {
        // Redirect to login only after loading is complete and user is not authenticated
        router.push("/masuk-akun");
      }
    }, [isAuthenticated, loading, router]);

    // Render the wrapped component if authenticated, or null while loading
    return loading ? null : isAuthenticated ? (
      <WrappedComponent {...props} />
    ) : null;
  };

  return Wrapper;
};

export default withAuth;
